<app-messages-center-navigation-tree [treeConfig]="treeConfig"
                                     [treeModel]="messagesCenterNavigationService.callbackQueuesTree.nodes"
                                     [selectedNode]="selectedNode">
</app-messages-center-navigation-tree>
